<script setup lang="ts">
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ToggleSwitch from '@/components/Elements/ToggleSwitch/ToggleSwitch.vue'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerFlagsStore = usePlayerFlagsStore()

const isTutorialDisabled = computed(() => {
  return playerFlagsStore.getFlag('tutorial_disable_tutorial') === 'true'
})

// Toggle handler for tutorial disable
const handleTutorialToggle = async () => {
  const newValue = isTutorialDisabled.value ? 'false' : 'true'
  await playerFlagsStore.setFlag('tutorial_disable_tutorial', newValue)
}
</script>

<template>
  <StandardCard :title="t('settings.help.title')">
    <div class="flex justify-between items-center">
      <div>
        {{ t('settings.help.disableTutorial') }}
      </div>
      <div class="flex items-center pb-1">
        <ToggleSwitch
          :modelValue="isTutorialDisabled"
          @update:modelValue="handleTutorialToggle"
        />
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>